import { DynamicStandaloneQuotebox } from '@/components/Quotebox';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorQuoteBox: LabradorComponent = ({ type, meta, data }) => {
  return (
    <DynamicStandaloneQuotebox
      data-content-index={meta.contentIndex}
      author={data.author}
      quote={data.quote}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorQuoteBox;
